import { OnboardingPdfDemo } from "@/components/onboarding-pdf-demo";
import { authClient } from "@/lib/auth-client";
import { createFileRoute } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";
import * as React from "react";

export const Route = createFileRoute("/onboarding-demo")({
	component: OnboardingDemoRoute,
});

function OnboardingDemoRoute() {
	const navigate = Route.useNavigate();
	const { data: session, isPending } = authClient.useSession();

	React.useEffect(() => {
		if (!session && !isPending) {
			navigate({
				to: "/login",
			});
		}
	}, [isPending, navigate, session]);

	if (isPending) {
		return (
			<div className="flex min-h-[70vh] items-center justify-center bg-[#efe6d3] px-6 py-20 text-slate-900">
				<div className="inline-flex items-center gap-3 rounded-full border border-slate-900/10 bg-white px-5 py-3 text-sm font-medium shadow-sm">
					<Loader2 className="h-4 w-4 animate-spin" />
					Checking your session...
				</div>
			</div>
		);
	}

	if (!session) {
		return null;
	}

	return <OnboardingPdfDemo sessionEmail={session.user.email} />;
}
